module.exports = __webpack_public_path__ + "img/c5.5b8b4403.png";